import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { LabelField } from 'components'
import { FedExDeliveryTypeDto, FedExPackageTypeDto, FedExShipmentDto, FedExUSStateCodeDto } from 'dtos/fedEx'
import { formatDateMoment, formatTimeMoment } from 'utils'

interface Props {
  deliveryTypes: FedExDeliveryTypeDto[]
  isLocked?: boolean
  onEdit: () => void
  packageTypes: FedExPackageTypeDto[]
  title: string
  usStateCodes: FedExUSStateCodeDto[]
  fedExShipment: FedExShipmentDto | undefined
}

export default function FedExLabelCard({ deliveryTypes, isLocked, onEdit, packageTypes, title, usStateCodes, fedExShipment }: Props) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm={true}>
              <Typography fontWeight='bold' variant='h6'>
                {title}
              </Typography>
            </Grid>

            <Grid item xs={12} sm='auto'>
              <Button disabled={isLocked} endIcon={<Edit />} onClick={onEdit} variant='text'>
                EDIT
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <LabelField
              label='Tracking #'
              value={fedExShipment?.trackingNumber}
              onClick={() => {
                if (fedExShipment?.trackingNumber) {
                  window.open(`https://fedex.com/wtrk/track/?trknbr=${fedExShipment.trackingNumber}`, '_blank')
                }
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <LabelField
              label='Package Type'
              value={
                fedExShipment?.packageType && packageTypes ? packageTypes.filter(pt => pt.enumeration === fedExShipment.packageType)[0]?.packageType : undefined
              }
            />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship Date' value={fedExShipment?.date ? formatDateMoment(fedExShipment.date) : undefined} />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship Time' value={fedExShipment?.time ? formatTimeMoment(fedExShipment.time) : undefined} />
          </Grid>

          <Grid item xs={12}>
            <LabelField
              label='Delivery Type'
              value={
                fedExShipment?.deliveryType && deliveryTypes
                  ? deliveryTypes.filter(dt => dt.enumeration === fedExShipment.deliveryType)[0]?.serviceType
                  : undefined
              }
            />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Weight' value={fedExShipment?.weightLbs ? `${fedExShipment.weightLbs} Lbs.` : undefined} />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship To Name' value={fedExShipment?.recipientContactPersonName} />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship To Phone #' value={fedExShipment?.recipientContactPhoneNumber} />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship To Address' value={fedExShipment?.recipientAddressStreetLine1} />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship To City' value={fedExShipment?.recipientAddressCity} />
          </Grid>

          <Grid item xs={12}>
            <LabelField
              label='Ship To State'
              value={
                fedExShipment?.recipientAddressStateOrProvinceCode && usStateCodes
                  ? usStateCodes.filter(ussc => ussc.code === fedExShipment.recipientAddressStateOrProvinceCode)[0]?.state
                  : undefined
              }
            />
          </Grid>

          <Grid item xs={12}>
            <LabelField label='Ship To Postal Code' value={fedExShipment?.recipientAddressPostalCode} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
